import { AvailableRoomPlan } from '@/__generated';
import React from 'react';

type Props = {
  plan: AvailableRoomPlan;
  className?: string;
};

export default function PlanTaxAndFee({ plan, className }: Props) {
  const ref = React.useRef<any>();

  const text = React.useMemo(() => {
    if (plan.includedFees && plan.includedTaxes) {
      return 'Included taxes and fees';
    }
    if (plan.includedTaxes) {
      return 'Included taxes';
    }
    if (plan.includedFees) {
      return 'Included fees';
    }
    return null;
  }, [plan]);

  if (!text) {
    return null;
  }
  return <div className={className}>{text}</div>;
}
